import React from "react"
import _ from "lodash"
import { Card } from "material-ui"
import AppStateStore from "../../../../../stores/AppStateStore"

interface IProps {
  rowHeight: number
  employeeList: any
}

const ScheduleResourcePlannerWeeklyDailyByEmployeeNameList: React.SFC<IProps> = (props: IProps) => {
  return (
    <Card>
      <div style={{ padding: 10, position: "relative" }} id="ScheduleViewPlace">
        <div style={{ display: "grid", gridTemplateColumns: "auto min-content", position: "sticky", top: AppStateStore.getTopBarHeight(), zIndex: 1, backgroundColor: "white" }}>
          <div style={{ gridColumn: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 700 }}>
              Employee
            </div>
            <div style={{ fontSize: 12, fontWeight: 500 }}>
              SHIFTS
            </div>
          </div>
        </div>
        {props.employeeList && props.employeeList.length > 0 &&
          <div>
            <table cellSpacing={0} cellPadding={3} style={{ fontSize: 11 }}>
              {props.employeeList.map((employee, index) => {
                return (
                  <tr key={index} style={{ height: props.rowHeight }}>
                    <td
                      className="TextOverflow"
                      style={{
                        gridRow: index,
                        height: props.rowHeight,
                        maxWidth: 100
                      }}
                    >
                      <b>
                        <span title={employee.Name}>
                          {employee.Name}
                        </span>
                      </b>
                      {employee.ExternalId &&
                        <span style={{ display: "block", color: "rgb(158, 158, 158)", fontSize: 10, marginTop: -5 }}>
                          Emp #: {employee.ExternalId}
                        </span>
                      }
                    </td>
                  </tr>
                )
              })}
            </table>
          </div>
        }
      </div>
    </Card>
  )
}

export default ScheduleResourcePlannerWeeklyDailyByEmployeeNameList